import script from "./CopyToClipboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./CopyToClipboard.vue?vue&type=script&lang=ts&setup=true"

import "./CopyToClipboard.vue?vue&type=style&index=0&id=4c249594&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c249594"]])

export default __exports__